import React, {Component} from 'react';

class Footer extends Component {
    render(){
        return (
            <footer id="rodape" className="col-12">
	            <div className="row">

	                <div className="col-sm-12 col-md-6">
	                    <div className="row">
	                        <div className="col-md-12">
	                            <p className="endereco text-left">SEDUC - Secretaria da Educação do Ceará</p>
	                            <p className="local text-left">Av. Gen. Afonso Albuquerque lima, s/n - Cambeba - Fortaleza -
	                                Ceará | CEP: 60.822-325</p>
	                        </div>
	                    </div>
	                </div>

	                <div className="col-sm-12 col-md-6  text-right">
	                    <div className="row">
	                        <div className="col-md-12">
	                            <p className="site">SEDUC.CE.GOV.BR - © 2018 – GOVERNO DO ESTADO DO CEARÁ</p>
	                            <p>TODOS OS DIREITOS RESERVADOS</p>
	                        </div>
	                    </div>
	                </div>

	            </div>
	        </footer>
        );
    }
}
export default Footer